// // import React, { useEffect, useMemo, useState } from 'react';
// // import { useLocation, Redirect } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';

// // import { signInTokenRequest } from '../../../../store/modules/auth/actions';
// // import {
// //   setSsoContext,
// //   setIdiomaCatalogo,
// //   globParamSuccess,
// // } from '../../../../store/modules/param/actions';

// // import api from '../../../../services/api';
// // import history from '../../../../services/history';

// // import { useQuery } from '../../../../lib/reactRouter';
// // import { opTipoAcao } from '../../../../lib/const';

// // import { AppContainer } from '../../../../components/Container';

// // const INITIAL_PARAMS = {
// //   token: null,
// //   matricula: null,
// //   email: null,
// //   idioma: null,
// // };

// // const INITIAL_ROUTER = {
// //   /** 0 = carregando · 1 = erro · 2 = ok (aguardando sessão para redirecionar) */
// //   situacao: 0,
// //   routeRedirect: null,
// // };

// // const IDIOMA_PADRAO = 'pt-BR';

// // /** idiomas do catálogo (espelham opIdiomaCatalogo): 0=PT,1=EN,2=IT,3=FR,4=RU,5=DE,6=ES */
// // const IDIOMAS_CATALOGO_VALIDOS = ['0', '1', '2', '3', '4', '5', '6'];

// // /** locales aceitos na URL -> código do catálogo */
// // const LOCALE_PARA_CODIGO = {
// //   pt: '0',
// //   'pt-br': '0',
// //   br: '0',
// //   en: '1',
// //   'en-us': '1',
// //   it: '2',
// //   fr: '3',
// //   ru: '4',
// //   de: '5',
// //   es: '6',
// //   'es-es': '6',
// // };

// // /** normaliza o idioma recebido (código 0-6 ou locale) para o código do catálogo */
// // function normalizaIdiomaCatalogo(valor) {
// //   if (valor === null || valor === undefined || valor === '') return null;

// //   const v = String(valor).trim();

// //   if (IDIOMAS_CATALOGO_VALIDOS.includes(v)) return v;

// //   return LOCALE_PARA_CODIGO[v.toLowerCase()] || null;
// // }

// // /** lê os claims do JWT (sem verificar assinatura) só para extrair emp/cat */
// // function lerClaims(token) {
// //   try {
// //     const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
// //     const pad = base64 + '==='.slice((base64.length + 3) % 4);
// //     const json = decodeURIComponent(
// //       atob(pad)
// //         .split('')
// //         .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
// //         .join('')
// //     );

// //     return JSON.parse(json);
// //   } catch (e) {
// //     return {};
// //   }
// // }

// // /**
// //  * Entrada de deep-link autenticado (SSO), TRAVADA em um único catálogo.
// //  * URL: /catalogo-sso?token=<JWT>&matricula=<NUMERO_SERIE>&email=<EMAIL>&idioma=<IDIOMA>
// //  *
// //  * Fluxo:
// //  *  1. lê os parâmetros da URL;
// //  *  2. usa o token de login para chamar POST /sso/catalogo (troca);
// //  *     -> o back resolve a série, valida o tenant e emite um token TRAVADO no catálogo;
// //  *  3. guarda o contexto SSO (e-mail do orçamento + idioma);
// //  *  4. estabelece a sessão com o token travado;
// //  *  5. redireciona para o catálogo resolvido (após a sessão estar pronta).
// //  */
// // function IntegraCatalogoSSO() {
// //   const dispatch = useDispatch();
// //   const routeQuery = useQuery(useLocation().search);

// //   const [router, setRouter] = useState(INITIAL_ROUTER);

// //   /** estado da sessão, para só redirecionar quando ela estiver estabelecida */
// //   const authAction = useSelector((state) => state.auth.action);
// //   const signed = useSelector((state) => state.auth.signed);

// //   useEffect(
// //     () => {
// //       async function carregaRecurso() {
// //         const parametroRota = {
// //           ...INITIAL_PARAMS,
// //           ...Object.fromEntries(routeQuery),
// //         };

// //         const { token, matricula, email, idioma } = parametroRota;

// //         /** token e matrícula são obrigatórios */
// //         if (!token || !matricula) {
// //           setRouter({ situacao: 1, routeRedirect: null });
// //           return;
// //         }

// //         try {
// //           /** usa o token de login para trocar por uma sessão travada no catálogo */
// //           api.defaults.headers.Authorization = `Bearer ${token}`;

// //           const { data } = await api.post('/sso/catalogo', {
// //             numeroSerie: matricula,
// //           });

// //           const { token: ssoToken, idCatalogo = 0, idioma: idiomaCatalogo } =
// //             data || {};

// //           if (!ssoToken || !(idCatalogo > 0)) {
// //             setRouter({ situacao: 1, routeRedirect: null });
// //             return;
// //           }

// //           /** empresa do catálogo (claim do token travado) */
// //           const { emp: idEmpresa } = lerClaims(ssoToken);

// //           /**
// //            * Carrega os parâmetros da empresa (GlobParam) AINDA com o token de
// //            * login — a sessão travada (ssoLock) bloqueia o prefixo /empresa,
// //            * então a busca precisa acontecer ANTES de trocar para o token SSO.
// //            */
// //           if (idEmpresa) {
// //             try {
// //               const { data: paramData } = await api.get(
// //                 `empresa/${idEmpresa}/glob-param`
// //               );

// //               const parametros = (
// //                 paramData.globParam || []
// //               ).map(({ chave, valor }) => ({ chave, valor }));

// //               dispatch(globParamSuccess(parametros));
// //             } catch (e) {
// //               /** não bloqueia a abertura do catálogo se os params falharem */
// //             }
// //           }

// //           /**
// //            * Idioma do catálogo: aceita os códigos novos (0-6) ou um locale
// //            * (pt-BR, en, it, ...). Define o filtro de idioma do catálogo.
// //            */
// //           const idiomaCodigo =
// //             normalizaIdiomaCatalogo(idioma) ||
// //             normalizaIdiomaCatalogo(idiomaCatalogo);

// //           if (idiomaCodigo) {
// //             dispatch(setIdiomaCatalogo(idiomaCodigo));
// //           }

// //           /** guarda o contexto SSO: e-mail do orçamento + idioma */
// //           dispatch(
// //             setSsoContext({
// //               quoteEmail: email || null,
// //               idioma: idioma || idiomaCatalogo || IDIOMA_PADRAO,
// //             })
// //           );

// //           /** estabelece a sessão com o token TRAVADO */
// //           api.defaults.headers.Authorization = `Bearer ${ssoToken}`;
// //           dispatch(signInTokenRequest(ssoToken, opTipoAcao.INTEGRACAO_TOKEN));

// //           /**
// //            * Segurança: remove o token da barra de endereço para não ficar no
// //            * histórico/Referer e não poder ser copiado e reaproveitado.
// //            */
// //           if (window.history && window.history.replaceState) {
// //             window.history.replaceState({}, document.title, '/catalogo-sso');
// //           }

// //           setRouter({ situacao: 2, routeRedirect: `/${idCatalogo}` });
// //         } catch (error) {
// //           /** token inválido/expirado, máquina não encontrada (404) ou ambígua (409) */
// //           setRouter({ situacao: 1, routeRedirect: null });
// //         }
// //       }

// //       carregaRecurso();
// //     },
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //     []
// //   );

// //   /** só redireciona quando a sessão SSO já estiver estabelecida */
// //   const sessaoPronta = signed || authAction === opTipoAcao.INTEGRACAO_TOKEN;

// //   const appRedirect = useMemo(
// //     () =>
// //       router.situacao === 2 && router.routeRedirect && sessaoPronta ? (
// //         <Redirect to={`/catalogo.partes${router.routeRedirect}`} />
// //       ) : (
// //         <AppContainer>
// //           {router.situacao === 1 ? (
// //             <>
// //               <span>
// //                 Não foi possível abrir o catálogo. Token inválido/expirado ou
// //                 máquina não encontrada. Gere um novo acesso na plataforma de
// //                 origem.
// //               </span>
// //               <button type="button" onClick={() => history.push('/login')}>
// //                 Acessar
// //               </button>
// //             </>
// //           ) : (
// //             <span>Carregando catálogo, aguarde...</span>
// //           )}
// //         </AppContainer>
// //       ),
// //     [router, sessaoPronta]
// //   );

// //   return appRedirect;
// // }

// // export { IntegraCatalogoSSO };

// import React, { useEffect, useMemo, useState } from 'react';
// import { useLocation, Redirect } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { FiAlertTriangle } from 'react-icons/fi';

// import { signInTokenRequest } from '../../../../store/modules/auth/actions';
// import {
//   setSsoContext,
//   setIdiomaCatalogo,
//   globParamSuccess,
// } from '../../../../store/modules/param/actions';

// import api from '../../../../services/api';
// import history from '../../../../services/history';

// import { useQuery } from '../../../../lib/reactRouter';
// import { opTipoAcao } from '../../../../lib/const';

// import logo from '../../../../assets/logo.svg';

// import {
//   SsoWrapper,
//   Card,
//   Logo,
//   Spinner,
//   IconBadge,
//   Title,
//   Message,
//   ActionButton,
// } from './styles';

// const INITIAL_PARAMS = {
//   token: null,
//   matricula: null,
//   email: null,
//   idioma: null,
// };

// const INITIAL_ROUTER = {
//   /** 0 = carregando · 1 = erro · 2 = ok (aguardando sessão para redirecionar) */
//   situacao: 0,
//   routeRedirect: null,
// };

// const IDIOMA_PADRAO = 'pt-BR';

// /** idiomas do catálogo (espelham opIdiomaCatalogo): 0=PT,1=EN,2=IT,3=FR,4=RU,5=DE,6=ES */
// const IDIOMAS_CATALOGO_VALIDOS = ['0', '1', '2', '3', '4', '5', '6'];

// /** locales aceitos na URL -> código do catálogo */
// const LOCALE_PARA_CODIGO = {
//   pt: '0',
//   'pt-br': '0',
//   br: '0',
//   en: '1',
//   'en-us': '1',
//   it: '2',
//   fr: '3',
//   ru: '4',
//   de: '5',
//   es: '6',
//   'es-es': '6',
// };

// /** normaliza o idioma recebido (código 0-6 ou locale) para o código do catálogo */
// function normalizaIdiomaCatalogo(valor) {
//   if (valor === null || valor === undefined || valor === '') return null;

//   const v = String(valor).trim();

//   if (IDIOMAS_CATALOGO_VALIDOS.includes(v)) return v;

//   return LOCALE_PARA_CODIGO[v.toLowerCase()] || null;
// }

// /** lê os claims do JWT (sem verificar assinatura) só para extrair emp/cat */
// function lerClaims(token) {
//   try {
//     const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
//     const pad = base64 + '==='.slice((base64.length + 3) % 4);
//     const json = decodeURIComponent(
//       atob(pad)
//         .split('')
//         .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
//         .join('')
//     );

//     return JSON.parse(json);
//   } catch (e) {
//     return {};
//   }
// }

// /**
//  * Entrada de deep-link autenticado (SSO), TRAVADA em um único catálogo.
//  * URL: /catalogo-sso?token=<JWT>&matricula=<NUMERO_SERIE>&email=<EMAIL>&idioma=<IDIOMA>
//  *
//  * Fluxo:
//  *  1. lê os parâmetros da URL;
//  *  2. usa o token de login para chamar POST /sso/catalogo (troca);
//  *     -> o back resolve a série, valida o tenant e emite um token TRAVADO no catálogo;
//  *  3. guarda o contexto SSO (e-mail do orçamento + idioma);
//  *  4. estabelece a sessão com o token travado;
//  *  5. redireciona para o catálogo resolvido (após a sessão estar pronta).
//  */
// function IntegraCatalogoSSO() {
//   const dispatch = useDispatch();
//   const routeQuery = useQuery(useLocation().search);

//   const [router, setRouter] = useState(INITIAL_ROUTER);

//   /** estado da sessão, para só redirecionar quando ela estiver estabelecida */
//   const authAction = useSelector((state) => state.auth.action);
//   const signed = useSelector((state) => state.auth.signed);

//   useEffect(
//     () => {
//       async function carregaRecurso() {
//         const parametroRota = {
//           ...INITIAL_PARAMS,
//           ...Object.fromEntries(routeQuery),
//         };

//         const { token, matricula, email, idioma } = parametroRota;

//         /** token e matrícula são obrigatórios */
//         if (!token || !matricula) {
//           setRouter({ situacao: 1, routeRedirect: null });
//           return;
//         }

//         try {
//           /** usa o token de login para trocar por uma sessão travada no catálogo */
//           api.defaults.headers.Authorization = `Bearer ${token}`;

//           const { data } = await api.post('/sso/catalogo', {
//             numeroSerie: matricula,
//           });

//           const { token: ssoToken, idCatalogo = 0, idioma: idiomaCatalogo } =
//             data || {};

//           if (!ssoToken || !(idCatalogo > 0)) {
//             setRouter({ situacao: 1, routeRedirect: null });
//             return;
//           }

//           /** empresa do catálogo (claim do token travado) */
//           const { emp: idEmpresa } = lerClaims(ssoToken);

//           /**
//            * Carrega os parâmetros da empresa (GlobParam) AINDA com o token de
//            * login — a sessão travada (ssoLock) bloqueia o prefixo /empresa,
//            * então a busca precisa acontecer ANTES de trocar para o token SSO.
//            */
//           if (idEmpresa) {
//             try {
//               const { data: paramData } = await api.get(
//                 `empresa/${idEmpresa}/glob-param`
//               );

//               const parametros = (
//                 paramData.globParam || []
//               ).map(({ chave, valor }) => ({ chave, valor }));

//               dispatch(globParamSuccess(parametros));
//             } catch (e) {
//               /** não bloqueia a abertura do catálogo se os params falharem */
//             }
//           }

//           /**
//            * Idioma do catálogo: aceita os códigos novos (0-6) ou um locale
//            * (pt-BR, en, it, ...). Define o filtro de idioma do catálogo.
//            */
//           const idiomaCodigo =
//             normalizaIdiomaCatalogo(idioma) ||
//             normalizaIdiomaCatalogo(idiomaCatalogo);

//           if (idiomaCodigo) {
//             dispatch(setIdiomaCatalogo(idiomaCodigo));
//           }

//           /** guarda o contexto SSO: e-mail do orçamento + idioma */
//           dispatch(
//             setSsoContext({
//               quoteEmail: email || null,
//               idioma: idioma || idiomaCatalogo || IDIOMA_PADRAO,
//             })
//           );

//           /** estabelece a sessão com o token TRAVADO */
//           api.defaults.headers.Authorization = `Bearer ${ssoToken}`;
//           dispatch(signInTokenRequest(ssoToken, opTipoAcao.INTEGRACAO_TOKEN));

//           /**
//            * Segurança: remove o token da barra de endereço para não ficar no
//            * histórico/Referer e não poder ser copiado e reaproveitado.
//            */
//           if (window.history && window.history.replaceState) {
//             window.history.replaceState({}, document.title, '/catalogo-sso');
//           }

//           setRouter({ situacao: 2, routeRedirect: `/${idCatalogo}` });
//         } catch (error) {
//           /** token inválido/expirado, máquina não encontrada (404) ou ambígua (409) */
//           setRouter({ situacao: 1, routeRedirect: null });
//         }
//       }

//       carregaRecurso();
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     []
//   );

//   /** só redireciona quando a sessão SSO já estiver estabelecida */
//   const sessaoPronta = signed || authAction === opTipoAcao.INTEGRACAO_TOKEN;

//   const appRedirect = useMemo(
//     () =>
//       router.situacao === 2 && router.routeRedirect && sessaoPronta ? (
//         <Redirect to={`/catalogo.partes${router.routeRedirect}`} />
//       ) : (
//         <SsoWrapper>
//           {router.situacao === 1 ? (
//             <Card>
//               {/* <Logo src={logo} alt="CDI - Catálogo Digital Interativo" pulse />
//               <Spinner /> */}
//               <IconBadge>
//                 <FiAlertTriangle size={38} />
//               </IconBadge>
//               <Title>Não foi possível abrir o catálogo</Title>
//               <Message>
//                 Seu link de acesso pode ter expirado ou a máquina não foi
//                 encontrada. Gere um novo acesso na plataforma de origem e tente
//                 novamente.
//               </Message>
//               <ActionButton
//                 type="button"
//                 onClick={() => history.push('/login')}
//               >
//                 Acessar a plataforma
//               </ActionButton>
//             </Card>
//           ) : (
//             <Card>
//               <Logo src={logo} alt="CDI - Catálogo Digital Interativo" pulse />
//               <Spinner />
//               <Title>Preparando seu catálogo</Title>
//               <Message>
//                 Estamos validando seu acesso e carregando as informações. Isso
//                 leva só um instante...
//               </Message>
//             </Card>
//           )}
//         </SsoWrapper>
//       ),
//     [router, sessaoPronta]
//   );

//   return appRedirect;
// }

// export { IntegraCatalogoSSO };

import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FiAlertTriangle } from 'react-icons/fi';

import { signInTokenRequest } from '../../../../store/modules/auth/actions';
import {
  setSsoContext,
  setIdiomaCatalogo,
  globParamSuccess,
} from '../../../../store/modules/param/actions';

import api from '../../../../services/api';
import history from '../../../../services/history';

import { useQuery } from '../../../../lib/reactRouter';
import { opTipoAcao } from '../../../../lib/const';

import logo from '../../../../assets/logo.svg';

import {
  SsoWrapper,
  Card,
  Logo,
  Spinner,
  IconBadge,
  Title,
  Message,
  ActionButton,
} from './styles';

const INITIAL_PARAMS = {
  token: null,
  matricula: null,
  email: null,
  idioma: null,
};

const INITIAL_ROUTER = {
  /** 0 = carregando · 1 = erro · 2 = ok (aguardando sessão para redirecionar) */
  situacao: 0,
  routeRedirect: null,
};

const IDIOMA_PADRAO = 'pt-BR';

/** idiomas do catálogo (espelham opIdiomaCatalogo): 0=PT,1=EN,2=IT,3=FR,4=RU,5=DE,6=ES */
const IDIOMAS_CATALOGO_VALIDOS = ['0', '1', '2', '3', '4', '5', '6'];

/** locales aceitos na URL -> código do catálogo */
const LOCALE_PARA_CODIGO = {
  pt: '0',
  'pt-br': '0',
  br: '0',
  en: '1',
  'en-us': '1',
  it: '2',
  fr: '3',
  ru: '4',
  de: '5',
  es: '6',
  'es-es': '6',
};

/** normaliza o idioma recebido (código 0-6 ou locale) para o código do catálogo */
function normalizaIdiomaCatalogo(valor) {
  if (valor === null || valor === undefined || valor === '') return null;

  const v = String(valor).trim();

  if (IDIOMAS_CATALOGO_VALIDOS.includes(v)) return v;

  return LOCALE_PARA_CODIGO[v.toLowerCase()] || null;
}

/** lê os claims do JWT (sem verificar assinatura) só para extrair emp/cat */
function lerClaims(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64 + '==='.slice((base64.length + 3) % 4);
    const json = decodeURIComponent(
      atob(pad)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    return JSON.parse(json);
  } catch (e) {
    return {};
  }
}

/**
 * Entrada de deep-link autenticado (SSO), TRAVADA em um único catálogo.
 * URL: /catalogo-sso?token=<JWT>&matricula=<NUMERO_SERIE>&email=<EMAIL>&idioma=<IDIOMA>
 *
 * Fluxo:
 *  1. lê os parâmetros da URL;
 *  2. usa o token de login para chamar POST /sso/catalogo (troca);
 *     -> o back resolve a série, valida o tenant e emite um token TRAVADO no catálogo;
 *  3. guarda o contexto SSO (e-mail do orçamento + idioma);
 *  4. estabelece a sessão com o token travado;
 *  5. redireciona para o catálogo resolvido (após a sessão estar pronta).
 */
function IntegraCatalogoSSO() {
  const dispatch = useDispatch();
  const routeQuery = useQuery(useLocation().search);

  const [router, setRouter] = useState(INITIAL_ROUTER);

  /** atraso mínimo (ms) exibindo a tela de "Preparando seu catálogo" antes
   * de redirecionar, para a transição não piscar */
  const [tempoMinimoOk, setTempoMinimoOk] = useState(false);

  /** estado da sessão, para só redirecionar quando ela estiver estabelecida */
  const authAction = useSelector((state) => state.auth.action);
  const signed = useSelector((state) => state.auth.signed);

  /** inicia o atraso mínimo assim que a tela é montada */
  useEffect(() => {
    const TEMPO_MINIMO_CARREGANDO = 4000; // 4s (faixa de 3 a 5s)
    const timer = setTimeout(
      () => setTempoMinimoOk(true),
      TEMPO_MINIMO_CARREGANDO
    );

    return () => clearTimeout(timer);
  }, []);

  useEffect(
    () => {
      async function carregaRecurso() {
        const parametroRota = {
          ...INITIAL_PARAMS,
          ...Object.fromEntries(routeQuery),
        };

        const { token, matricula, email, idioma } = parametroRota;

        /** token e matrícula são obrigatórios */
        if (!token || !matricula) {
          setRouter({ situacao: 1, routeRedirect: null });
          return;
        }

        try {
          /** usa o token de login para trocar por uma sessão travada no catálogo */
          api.defaults.headers.Authorization = `Bearer ${token}`;

          const { data } = await api.post('/sso/catalogo', {
            numeroSerie: matricula,
          });

          const { token: ssoToken, idCatalogo = 0, idioma: idiomaCatalogo } =
            data || {};

          if (!ssoToken || !(idCatalogo > 0)) {
            setRouter({ situacao: 1, routeRedirect: null });
            return;
          }

          /** empresa do catálogo (claim do token travado) */
          const { emp: idEmpresa } = lerClaims(ssoToken);

          /**
           * Carrega os parâmetros da empresa (GlobParam) AINDA com o token de
           * login — a sessão travada (ssoLock) bloqueia o prefixo /empresa,
           * então a busca precisa acontecer ANTES de trocar para o token SSO.
           */
          if (idEmpresa) {
            try {
              const { data: paramData } = await api.get(
                `empresa/${idEmpresa}/glob-param`
              );

              const parametros = (
                paramData.globParam || []
              ).map(({ chave, valor }) => ({ chave, valor }));

              dispatch(globParamSuccess(parametros));
            } catch (e) {
              /** não bloqueia a abertura do catálogo se os params falharem */
            }
          }

          /**
           * Idioma do catálogo: aceita os códigos novos (0-6) ou um locale
           * (pt-BR, en, it, ...). Define o filtro de idioma do catálogo.
           */
          const idiomaCodigo =
            normalizaIdiomaCatalogo(idioma) ||
            normalizaIdiomaCatalogo(idiomaCatalogo);

          if (idiomaCodigo) {
            dispatch(setIdiomaCatalogo(idiomaCodigo));
          }

          /** guarda o contexto SSO: e-mail do orçamento + idioma */
          dispatch(
            setSsoContext({
              quoteEmail: email || null,
              idioma: idioma || idiomaCatalogo || IDIOMA_PADRAO,
            })
          );

          /** estabelece a sessão com o token TRAVADO */
          api.defaults.headers.Authorization = `Bearer ${ssoToken}`;
          dispatch(signInTokenRequest(ssoToken, opTipoAcao.INTEGRACAO_TOKEN));

          /**
           * Segurança: remove o token da barra de endereço para não ficar no
           * histórico/Referer e não poder ser copiado e reaproveitado.
           */
          if (window.history && window.history.replaceState) {
            window.history.replaceState({}, document.title, '/catalogo-sso');
          }

          setRouter({ situacao: 2, routeRedirect: `/${idCatalogo}` });
        } catch (error) {
          /** token inválido/expirado, máquina não encontrada (404) ou ambígua (409) */
          setRouter({ situacao: 1, routeRedirect: null });
        }
      }

      carregaRecurso();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  /** só redireciona quando a sessão SSO já estiver estabelecida */
  const sessaoPronta = signed || authAction === opTipoAcao.INTEGRACAO_TOKEN;

  const appRedirect = useMemo(
    () =>
      router.situacao === 2 &&
      router.routeRedirect &&
      sessaoPronta &&
      tempoMinimoOk ? (
        <Redirect to={`/catalogo.partes${router.routeRedirect}`} />
      ) : (
        <SsoWrapper>
          {router.situacao === 1 ? (
            <Card>
              <IconBadge>
                <FiAlertTriangle size={38} />
              </IconBadge>
              <Title>Não foi possível abrir o catálogo</Title>
              <Message>
                Seu link de acesso pode ter expirado ou a máquina não foi
                encontrada. Gere um novo acesso na plataforma de origem e tente
                novamente.
              </Message>
              <ActionButton
                type="button"
                onClick={() => history.push('/login')}
              >
                Acessar a plataforma
              </ActionButton>
            </Card>
          ) : (
            <Card>
              <Logo src={logo} alt="CDI - Catálogo Digital Interativo" pulse />
              <Spinner />
              <Title>Preparando seu catálogo</Title>
              <Message>
                Estamos validando seu acesso e carregando as informações. Isso
                leva só um instante...
              </Message>
            </Card>
          )}
        </SsoWrapper>
      ),
    [router, sessaoPronta, tempoMinimoOk]
  );

  return appRedirect;
}

export { IntegraCatalogoSSO };
